import { render, staticRenderFns } from "./academicInformation.vue?vue&type=template&id=5667065e&scoped=true"
import script from "./academicInformation.vue?vue&type=script&lang=js"
export * from "./academicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667065e",
  null
  
)

export default component.exports